import { useState, useCallback } from 'react';

interface UseQuestionResolutionProps {
  hasLibrasVideo: boolean;
}

interface UseQuestionResolutionReturn {
  questionTextShow: boolean;
  setQuestionTextShow: (value: boolean) => void;
  questionVideoStart: boolean;
  setQuestionVideoStart: (value: boolean) => void;
  modalVideoOption: boolean;
  setModalVideoOption: (value: boolean) => void;
  isLibrasVideo: boolean;
  setIsLibrasVideo: (value: boolean) => void;
  handlePlayVideo: () => void;
  handleReadResolution: () => void;
  formulaModalShow: boolean;
  setFormulaModalShow: (value: boolean) => void;
  handleShowFormula: () => void;
}

export const useQuestionResolution = ({
  hasLibrasVideo,
}: UseQuestionResolutionProps): UseQuestionResolutionReturn => {
  const [questionTextShow, setQuestionTextShow] = useState(false);
  const [questionVideoStart, setQuestionVideoStart] = useState(false);
  const [modalVideoOption, setModalVideoOption] = useState(false);
  const [isLibrasVideo, setIsLibrasVideo] = useState(false);
  const [formulaModalShow, setFormulaModalShow] = useState(false);

  const handlePlayVideo = useCallback(() => {
    if (hasLibrasVideo) {
      setModalVideoOption(true);
    } else {
      setQuestionVideoStart(true);
    }
  }, [hasLibrasVideo]);

  const handleReadResolution = useCallback(() => {
    setQuestionTextShow(true);
  }, []);

  const handleShowFormula = useCallback(() => {
    setFormulaModalShow(true);
  }, []);

  return {
    questionTextShow,
    setQuestionTextShow,
    questionVideoStart,
    setQuestionVideoStart,
    modalVideoOption,
    setModalVideoOption,
    isLibrasVideo,
    setIsLibrasVideo,
    handlePlayVideo,
    handleReadResolution,
    formulaModalShow,
    setFormulaModalShow,
    handleShowFormula,
  };
};
